import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if the user has accepted or denied cookies
        const cookieConsent = Cookies.get("cookieConsent");
        if (!cookieConsent) {
            setShowBanner(true);
        }
    }, []);

    const acceptCookies = () => {
        Cookies.set("cookieConsent", "accepted", { expires: 365 }); // Store for 1 year
        setShowBanner(false);
    };
    // const denyCookies = () => {
    //     // Cookies.set("cookieConsent", "denied", { expires: 30 }); // Store for 30 days
    //     setShowBanner(false);
    // };

    if (!showBanner) return null;
    return (
        <div className="w-2/6  fixed bottom-16 left-1/2 transform translate-x-40 bg-orange text-white p-3 rounded-lg shadow-2xl flex flex-col gap-3 z-[9999]">
            <p className="text-base laptop::text-base font-semibold text-center md:text-left">
                🍪 We use cookies to improve your experience on our website. By browsing this website, you agree to our use of cookies. Read more about our Privacy Policy.
            </p>
            <div className="flex gap-4 mt-3 md:mt-0">
                <button
                    onClick={acceptCookies}
                    className="px-6 py-2 bg-white text-sm text-black font-bold rounded-md transition-all duration-300 hover:bg-gray-200 shadow-lg"
                >
                    Accept Cookies
                </button>
                {/* <button
            onClick={denyCookies}
            className="px-4 py-2 bg-white text-sm text-black font-bold rounded-full transition-all duration-300 hover:bg-gray-700 shadow-lg"
        >
            Deny
        </button> */}
            </div>
        </div>

    );
};

export default CookieConsent;
